import React from "react"
import { useState } from "react"
import { Row, Col } from "./RowCol";
import { LucideIcon } from "./lucide_icon";

const ComponentCard = ({
    icon = "",
    showIcon = false,
    componentId = 0,
    componentName = "",
    componentDescription = "",
    showComponentDescription = "",
    componentType = "",
    componentCount = 0,
    showComponentCount = false,
    clicked = false,
    draggable = false,
    onClick = () => { },
}) => {
    const [selectedElement, setSelectedElement] = useState(null)
    return (
        <div
            key={componentId}
            className={`flex items-center gap-3 p-3 rounded-lg cursor-move group border transition-colors ${clicked
                    ? "bg-blue-50 border-blue-200"
                    : "border-gray-100 hover:bg-gray-50"
                }`}
            draggable={draggable}
            onDragStart={(e) => {
                e.dataTransfer.setData("component-id", componentId)
                e.dataTransfer.setData("component-type", componentType)
                e.dataTransfer.setData("component-name", componentName)
                // 可以傳更多資訊，type / icon 等
            }}
            onClick={() => {
                setSelectedElement({
                    id: componentId,
                    content: componentName,
                    x: 100,
                    y: 100,
                    width: 200,
                    height: 40,
                })
                onClick(componentId, {
                    id: componentId,
                    content: componentName,
                    x: 100,
                    y: 100,
                    width: 200,
                    height: 40,
                })
            }}
        >
            {showIcon ?
                <div
                    className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${clicked ? "bg-blue-200" : "bg-gray-100 group-hover:bg-gray-200"
                        }`}
                >
                    <LucideIcon name={icon} className="w-4 h-4" />
                    {/* {IconComponent && <IconComponent className="w-4 h-4" />} */}
                </div>
                : <></>}
            <div className="flex-1">
                <div className="flex items-center gap-2">
                    <Row className="text-sm font-medium text-gray-900">{componentName}</Row>
                    {componentCount !== undefined && componentCount > 0 && (
                        showComponentCount ? <Row className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full">{componentCount}</Row> : <></>
                    )}
                </div>
                {showComponentDescription ? <Row className="text-xs text-gray-500">{componentDescription}</Row> : <></>}
            </div>
        </div>
    )
}

export default ComponentCard;